import { render, staticRenderFns } from "./compRemark.vue?vue&type=template&id=5d89748d"
import script from "./compRemark.vue?vue&type=script&lang=js"
export * from "./compRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports